type BadgeNavigator = Navigator & {
  setAppBadge?: (contents?: number) => Promise<void>;
  clearAppBadge?: () => Promise<void>;
};

export async function setUnreadAppBadge(unreadCount: number) {
  const badgeNavigator = navigator as BadgeNavigator;
  const count = Math.max(0, Math.floor(Number(unreadCount) || 0));
  try {
    if (count > 0 && badgeNavigator.setAppBadge) await badgeNavigator.setAppBadge(count);
    else if (badgeNavigator.clearAppBadge) await badgeNavigator.clearAppBadge();
    else if (badgeNavigator.setAppBadge) await badgeNavigator.setAppBadge(0);
  } catch {
    // Badging is an enhancement. Unsupported/denied badge updates must not
    // disturb navigation, chat events, or push delivery.
  }
}
